// Finishes sign-up for good: tells the server the person's original invitation code is
// used up. The login screens call this too, fire-and-forget; if that call was lost the
// code would stay open, so every signed-in page load retries until one succeeds (once
// per browser tab per person). Renders nothing.
import { useEffect } from 'react';
import { useFileContext } from '../../ContextAPI/FileContext';
import { completeSignup } from '../Signup/signupApi';

const storageKey = (email) => `signupCompleted:${(email || '').trim().toLowerCase()}`;

function alreadyDone(email) {
  try {
    return window.sessionStorage.getItem(storageKey(email)) === '1';
  } catch (e) {
    return false;
  }
}

function rememberDone(email) {
  try {
    window.sessionStorage.setItem(storageKey(email), '1');
  } catch (e) {
    /* storage blocked: it retries on the next load, which is harmless */
  }
}

const inFlight = new Set();

export default function SignupCompletion() {
  const { auth, userEmail } = useFileContext();

  useEffect(() => {
    if (!auth || !userEmail) return;
    const key = storageKey(userEmail);
    if (alreadyDone(userEmail) || inFlight.has(key)) return;
    inFlight.add(key);
    completeSignup()
      .then(() => rememberDone(userEmail))
      .catch((error) => console.warn('Could not finish sign-up; will retry on the next load.', error))
      .finally(() => inFlight.delete(key));
  }, [auth, userEmail]);

  return null;
}
